var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgReliable = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 80,
  height: 80,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m18.741 4.057 1.19 10.255-3.048-2.04-3.509-8.35 5.367.135ZM7.011 7.97l7.073 7.52-.958.489-8.971-5.569L7.01 7.97ZM12.629 18.835l-10.317.362-.047 3.757 11.068-2.921-.704-1.198Z",
  className: "reliable_svg__secondary"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m18.36 22.966 2.496 37.521L43.46 73.864l22.604-13.44L69 23.17l-6.165-6.633-38.832.745-5.643 5.685Z",
  className: "reliable_svg__primary"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M58.49 37.652 40.605 54.755 29.826 44.75l6.792-6.784 4.75 6.267 12.618-13.365 4.504 6.784Z",
  fill: "#fff"
})));
export default SvgReliable;